import { render, staticRenderFns } from "./BiometricsList.vue?vue&type=template&id=0449737c"
import script from "./BiometricsList.vue?vue&type=script&lang=js"
export * from "./BiometricsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports